import { render, staticRenderFns } from "./Categories.create.vue?vue&type=template&id=57bae6bc&"
import script from "./Categories.create.vue?vue&type=script&lang=js&"
export * from "./Categories.create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports